/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * This service enables external control and communication between the "PlanTicketsFilterComponent"
 * and other parts of the application after the component's initialization. It also manages the
 * opening and closing of the filter panel as needed and the "quick search" component in top navigation bar.
 */
@Injectable({ providedIn: 'root' })
export class PlanTicketsFilterRemoteControlService {
	private _openPlanTicketsFilter$ = new BehaviorSubject<boolean>(false);
	private _quickSearchValue$ = new BehaviorSubject<string>('');
	private _disableQuickSearch$ = new BehaviorSubject<boolean>(false);

	/** emits when the panel is opened or closed, true is open */
	public openPlanTicketsFilter$: Observable<boolean> = this._openPlanTicketsFilter$.asObservable();
	public quickSearchValue$: Observable<string> = this._quickSearchValue$.asObservable();
	public disableQuickSearch$: Observable<boolean> = this._disableQuickSearch$.asObservable();

	updateQuickSearchValue(value: string) {
		this._quickSearchValue$.next(value);
	}

	togglePlanTicketsFilter() {
		this._openPlanTicketsFilter$.next(!this._openPlanTicketsFilter$.value);
	}

	closePlanTicketsFilter() {
		this._quickSearchValue$.next('');
		this._openPlanTicketsFilter$.next(false);
	}

	openPlanTicketsFilter() {
		this._openPlanTicketsFilter$.next(true);
	}

	disableQuickSearch(disable: boolean) {
		this._disableQuickSearch$.next(disable);
		this._quickSearchValue$.next('');
	}

	constructor() {}
}
